import React from 'react'
import './index.less'
import appsetting from '../../init/appsetting'
export default class Footer extends React.Component {
  componentWillMount () {
    let versionDom = this.getversion(appsetting.version)
    this.setState({
      versionDom
    })
  }
  getversion (version) {
    return version ? <span>{version}</span> : ''
  }
  render () {
    return (
      <div className="footer">
        版权所有：慧途科技(惠州)有限责任公司 | 版本：{this.state.versionDom}
      </div>
    )
  }
}